import { shortWallet } from "@utils/shortWallet";
import styles from "../Profile.module.scss";
import cn from "classnames";
import { FC } from "react";
import { useWallet } from "@stores/wallet.store";
import { showPromiseToast } from "@utils/showToast";
import { WalletDropdownButton } from "@/components/ui/wallet-dropdown-button";

interface Props {
    showSelectModal(): void;
    small?: boolean;
    plain?: boolean;
}

const WalletAddress: FC<Props> = ({ showSelectModal, small, plain }) => {
    const wallet = useWallet((state) => state.currentWallet);

    const handleCopy = () => {
        showPromiseToast(navigator.clipboard.writeText(wallet.friendlyAddress), "Wallet address copied to clipboard");
    };

    return (
        <div className={styles.wallet}>
            <div className={styles.select}>
                {!small && (
                    <div className={styles.selectTop}>
                        <div className={styles.selectLeft} onClick={handleCopy}>
                            <img height={15} width={15} src="/images/profile/copy.svg" alt="" />
                        </div>
                        <button onClick={showSelectModal} className={styles.selectLeft}>
                            <span className={cn(styles.selectText, small && "text-sm")}>
                                {shortWallet(wallet.friendlyAddress)}
                            </span>
                            <img src="/images/profile/down.svg" alt="" />
                        </button>
                        <img src="/images/profile/key.svg" alt="" />
                    </div>
                )}

                {small && (
                    <WalletDropdownButton
                        isOpen={false}
                        onClick={showSelectModal}
                        label={shortWallet(wallet.friendlyAddress)}
                        className={plain ? "!border-none !bg-transparent w-fit" : ""}
                    />
                )}
            </div>
        </div>
    );
};

export default WalletAddress;
